import { queryOptions } from '@tanstack/react-query'
import { api, unwrap } from '~/lib/api'

// "Heute" is always about today, so its key carries the current season (not an archive season the
// member is browsing elsewhere). ['home'] is invalidated by every module that changes what it shows.
export const homeKeys = {
  all: ['home'] as const,
  screen: (teamId: string, season: string) => ['home', teamId, season] as const,
}

export const homeQuery = (teamId: string, season: string) =>
  queryOptions({
    queryKey: homeKeys.screen(teamId, season),
    queryFn: () => unwrap(api.home.$get({ query: teamId ? { teamId } : {} })),
  })

export type Home = Awaited<ReturnType<NonNullable<ReturnType<typeof homeQuery>['queryFn']>>>
export type HomeTraining = NonNullable<Home['nextTraining']>
export type HomeMatch = NonNullable<Home['nextMatch']>
export type HomeOpen = Home['open'][number]
export type HomeLeague = NonNullable<Home['league']>
export type HomeClub = NonNullable<Home['club']>
export type HomeMe = NonNullable<Home['me']>


export { loaderScope as homeScope } from '~/lib/session'
